import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { FDStack } from '@facet-wealth/design';
import Content from '../CIPFinishTemplate/Content';


const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  desktopMargin: {
    marginLeft: theme.spacing(10),
  },
  form: {
    maxWidth: '100%',
  },
});
const CIPFinishActivationTemplate = ({
  className,
  classes,
  resource,
}) => {
  const { loadHousehold: refreshHousehold } = useSimpleHousehold();

  useComponentDidMount(async () => {
    await refreshHousehold();
  });

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={(props) => <>
        <FDStack spacing={2} direction={'column'} alignItems={'center'}>
          <ImageRel height={'175px'} relationship={resource.relationship(fr.relationships.image.name)} />
          <PageContentTop
            badgeImage={resource.attr('imageUrl')}
            title={resource.attr('title')}
            subtitle={resource.attr('subtitle')}
          />
        </FDStack>
        <Content {...props} />
      </>}
      LayoutProps={{
        resource,
      }}
    />
  );
};

CIPFinishActivationTemplate.defaultProps = {
  className: '',
};

CIPFinishActivationTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(CIPFinishActivationTemplate);
